import * as React from 'react';
import { LinearProgress, Typography } from '@mui/material';

function LinearProgressWithLabel(props) {
    return (
        <div className="flex items-center">
            <div className="w-full	mr-1">
                <LinearProgress variant="determinate" {...props} />
            </div>
            <div>
                <Typography
                    variant="body2"
                    color="text.secondary"
                >{`${Math.round(props.value)}%`}</Typography>
            </div>
        </div>
    );
}
export default LinearProgressWithLabel;
